import axios from 'axios'
import { login } from '@/services/auth/login'
import { api } from '@/services'

const url = process.env.VUE_APP_API_URL

const state = {
  onboardingProfile: {},
  onboardingStatus: {},
  onboardingContract: '',
  onboardingContractId: '',
  onboardingContractTypeId: '',
  onboardingStepsNavigation: 1,
  onboardingStepsNextEnabled: true,
  onboardingServices: [],
  onboardingSelectedServices: [],
  onboardingServicesForQnt: [],
  onboardingSelectedPlan: 'SINGLE_PURCHASE',
  onboardingMaxServices: 15,
  onboardingServicesAndTotal: {},
  onboardingAppointmentValue: '',
  onboardingLoading: false,
}

const getters = {
  onboardingProfile: (state) => state.onboardingProfile,
  onboardingContract: (state) => state.onboardingContract,
  onboardingContractId: (state) => state.onboardingContractId,
  onboardingContractTypeId: (state) => state.onboardingContractTypeId,
  onboardingStepsNavigation: (state) => state.onboardingStepsNavigation,
  onboardingStepsNextEnabled: (state) => state.onboardingStepsNextEnabled,
  onboardingServices: (state) => state.onboardingServices,
  onboardingSelectedServices: (state) => state.onboardingSelectedServices,
  onboardingServicesForQnt: (state) => state.onboardingServicesForQnt,
  onboardingSelectedPlan: (state) => state.onboardingSelectedPlan,
  onboardingServicesAndTotal: (state) => state.onboardingServicesAndTotal,
  onboardingAppointmentValue: (state) => state.onboardingAppointmentValue,
  onboardingLoading: (state) => state.onboardingLoading,
}

const actions = {
  handleOnboardingSteps({ commit, getters }, onboardingStatus) {
    const status = {
      NO_CITY: 1,
      NO_CREDIT: 1,
      NO_SUBSCRIPTION: 1,
      CITY_NOT_AVAILABLE: 7,
    }

    commit('setOnboardingStepsNavigation', status[onboardingStatus])
  },

  async createProfile({ commit, dispatch }, payload) {
    commit('setIsLoading', true)

    const { email, password } = payload?.customerCreatProfileRequest

    await axios
      .post(`${url}/web/customerOnboarding/createProfile`, payload)
      .then(({ status }) => {
        if (status === 200) {
          Promise.resolve(
            localStorage.setItem('onboardingUser', 'true')
          ).then(() => login({ username: email, password }))
        } else {
          commit('setIsLoading', false)
          dispatch('showErrorMessage', 'Erro ao criar perfil via onboarding.')
        }
      })
      .catch(({ response: { data } }) => {
        commit('setIsLoading', false)
        dispatch('showErrorMessage', data.message)
      })
  },

  async onboardingCreateAddress({ commit, dispatch }, address) {
    commit('setIsLoading', true)

    await api
      .post('/web/customerOnboarding/setLocationData', address)
      .then(({ data }) => {
        commit('setOnboardingServices', data.services)

        if (data.services.length <= 0) {
          commit('setOnboardingStepsNavigation', 7)
        } else {
          commit(
            'setOnboardingStepsNavigation',
            this.getters.onboardingStepsNavigation + 1
          )
        }
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  async onboardingCreateContract({ commit, dispatch }, contract) {
    commit('setIsLoading', true)

    await api
      .post('/web/customerOnboarding/createContract', contract)
      .then(({ data }) => {
        commit('setOnboardingContractId', data?.service_contracts[0]?.id)
        commit('setOnboardingServicesForQnt', data?.service_contracts)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  async onboardingRequestContract({ commit, dispatch }, contractType) {
    commit('setIsLoading', true)

    await api
      .get(`web/agreement/current?type=${contractType}`)
      .then((response) => {
        const { id, html_content } = response.data

        commit('setOnboardingContract', html_content)
        commit('setOnboardingContractTypeId', id)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  async onboardingAcceptContract({ commit, dispatch }) {
    commit('setOnboardingLoading', true)

    await api
      .post('/web/agreement/accept', {
        agreement_id: this.state.onboarding.onboardingContractTypeId,
      })
      .then(() => {
        commit('setOnboardingStepsNavigation', 6)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setOnboardingLoading', false))
  },

  async calculateAppointmentValue({ commit, dispatch }, realty) {
    commit('setIsLoading', true)

    await api
      .post('/web/customerOnboarding/calculateAppointmentValue', realty)
      .then(({ data }) => {
        commit('setOnboardingAppointmentValue', data)
        commit(
          'setOnboardingStepsNavigation',
          this.getters.onboardingStepsNavigation + 1
        )
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  async onboardingFetchAvailableServices({ commit }, params) {
    commit('setIsLoading', true)

    try {
      const { data } = await api.get(
        '/web/contract/listAvailableDefaultServiceContracts?contractType=SINGLE_PURCHASE'
      )
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setOnboardingProfile: (state, data) => {
    state.onboardingProfile = { ...state.onboardingProfile, ...data }
  },

  setOnboardingStepsNavigation: (state, step) => {
    state.onboardingStepsNavigation = step
  },

  setOnboardingStepsNextEnabled: (state, status) => {
    state.onboardingStepsNavigation = status
  },

  setOnboardingServices: (state, services) => {
    state.onboardingServices = services
  },

  setOnboardingContract: (state, contract) => {
    state.onboardingContract = contract
  },

  setOnboardingContractId: (state, id) => {
    state.onboardingContractId = id
  },

  setOnboardingContractTypeId: (state, id) => {
    state.onboardingContractTypeId = id
  },

  setOnboardingSelectedServices: (state, selectedServices) => {
    state.onboardingSelectedServices = selectedServices
  },

  setOnboardingSelectedPlan: (state, selectedPlan) => {
    state.onboardingSelectedPlan = selectedPlan
  },

  setOnboardingServicesForQnt: (state, services) => {
    state.onboardingServicesForQnt = services
  },

  setOnboardingServicesAndTotal: (state, servicesAndTotal) => {
    state.onboardingServicesAndTotal = servicesAndTotal
  },

  setOnboardingAppointmentValue: (state, realtyValue) => {
    state.onboardingAppointmentValue = realtyValue
  },

  setOnboardingLoading: (state, status) => {
    state.onboardingLoading = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
